import { LOCATION_CHANGE } from 'Config/types';
import defaultState from 'Config/defaultState';
import util from 'Utils';

const { getObjectFromString } = util.query;

/**
 * This reducer will update the state with the most recent location history
 * to which it has transitioned to. This may not be in sync with the router,
 * particularly if you have asynchronously-loaded routes,
 * so reading from and relying on this state is discouraged.
 *
 * Since we don't care about any routing information other than query,
 * we are only including the query in this and not all the location information
 */
export default function routerReducer(
  state = defaultState.router,
  action = {}
) {
  switch (action.type) {
    case LOCATION_CHANGE: {
      const query = getObjectFromString(action.payload.search);
      return {
        ...state,
        ...query,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/router.js